module.exports = __webpack_public_path__ + "static/media/wii_fit_trainer.1d46068c.png";